import React from "react";
import "./IleTadam.scss";
import IslandVideo from "../../components/ui/IslandVideo";

export default function IleGrou() {
	return (
		<>
			<div id='iletadam' className='Island'>
				<div className='video_container'>
					<IslandVideo
						webmSrc='/videos/iles/20241219_ile_tadam-vp9-chrome.webm'
						mp4Src='/videos/iles/20241219_ile_tadam-hevc-safari.mp4'
					/>
				</div>
				<div className='text'>
					<h2 className='island_title'>Tadam</h2>
					<p>Des jeux et des réflexions pour faire durer la magie du spectacle...</p>
				</div>
			</div>
		</>
	);
}
